// libraries
import React from "react";

// components
import { TeamSettingsAdminNoMeetingDay } from "#webapp/src/components/teams-settings/team-settings-admin-form/team-settings-admin-no-meeting-day";
import { TrialProBadgeWithTooltip } from "@clockwise/web-commons/src/ui/trial-pro-badge-with-tooltip";
import { TeamSections } from "../web-settings";

// material-ui
import { Link } from "@clockwise/design-system";
import { useMonetization } from "../../../hooks/useMonetization";

// ~-~-~-~-~-~-~-
// Team No Meeting Day Settings
// ~-~-~-~-~-~-~-
interface Props {
  teamId: string;
}

export const TeamNoMeetingDay = ({ teamId }: Props) => {
  const { getCopyForMonetizationBadges, daysLeftInTrial } = useMonetization();

  return (
    <div cw-id={`web-settings-${TeamSections.TeamNoMeetingDay}`} className="cw-mb-7">
      <div className="cw-flex cw-gap-2 cw-mb-4">
        <div className="cw-heading-xl">Team no-meeting day</div>
        <TrialProBadgeWithTooltip
          tooltipType={getCopyForMonetizationBadges("NMD")}
          showToolTip={true}
          daysLeftOnTrial={daysLeftInTrial || undefined}
          badgeText="Teams"
          width={400}
        />
      </div>

      <div className="cw-body-lg cw-mb-6">
        Your team can dedicate one day of the week for a “no-meeting day.” Clockwise will try to
        keep that day meeting-free for team members, and can optionally notify meeting organizers
        when they schedule over your team's no-meeting day.{" "}
        <Link
          href="https://support.getclockwise.com/hc/en-us/articles/360041160532-Team-features-Team-no-meeting-day"
          target="_blank"
          rel="noreferrer"
        >
          Learn more
        </Link>
        .
      </div>
      <TeamSettingsAdminNoMeetingDay teamId={teamId} />
    </div>
  );
};
